
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import BlockHeight from './pages/BlockHeight';
import BlockHashPage from './pages/BlockHashPage';
import SmartNodesPage from './pages/SmartNodesPage';
import SmartnodeLockedCoinsPage from './pages/SmartnodeLockedCoinsPage';
import PeerInfoPage from './pages/PeerInfoPage';
import AddressPage from './pages/AddressPage';
import TopAddressesPage from './pages/TopAddressesPage';
import ClaimAddressPage from './pages/ClaimAddressPage';
import Txid from './pages/Txid';
import ApiDocsPage from './pages/ApiDocsPage';

const App = () => {
  return (
    <Router>
      <div>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/address/:address" element={<AddressPage />} />
          <Route path="/top-addresses" element={<TopAddressesPage />} />
          <Route path="/claim-address" element={<ClaimAddressPage />} />
          <Route path="/block-hash/:hash" element={<BlockHashPage />} />
          <Route path="/block-height/:blockHeight" element={<BlockHeight />} />
          <Route path="/smartnodes" element={<SmartNodesPage />} />
          <Route path="/locked-coins" element={<SmartnodeLockedCoinsPage />} />
          <Route path="/peerinfo" element={<PeerInfoPage />} />
          <Route path="/txid/:txid" element={<Txid />} />
          <Route path="/api-docs" element={<ApiDocsPage />} />

        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
